/**
 * A COMPANY'S LIFECYCLE STATE IS SHOWN, NEVER INFERRED. 09 decision 10, §5.1.
 *
 * PROVEN (addendum §F): `company_tags.json` holds `active=true` for 8, `active=false` for 138, and
 * NO `active` key at all for 167 — the largest single group — while two code paths resolve that
 * absence in opposite directions (DENY at login, ALLOW during session validation). The UI's job is
 * therefore to DISPLAY the state the server states, and never to guess one from an absence.
 *
 * 09 §9.5 A3: colour is never the only carrier of meaning, so every chip is also a Hebrew word.
 */

import type { CompanyLifecycleStatus } from '../api/contract';
import { lifecycleStatusHe } from '../api/adminVocabulary';

/**
 * The Hebrew itself lives in `adminVocabulary.ts` with every other server enum, because it is now
 * needed in a sentence as well as in a chip — `lifecycleText.ts` writes *"מהמצב הנוכחי אפשר לעבור
 * אל: …"* from the SAME map. Two copies of the eight names is two catalogues, which is the defect
 * `contract.mirror.test.ts` exists to catch one directory up.
 */
export function LifecycleChip({ status }: { readonly status: CompanyLifecycleStatus }): JSX.Element {
  return (
    <span className="chip chip--lifecycle" data-lifecycle={status}>
      {lifecycleStatusHe(status)}
    </span>
  );
}
